<template>
    <div
        ref="index" 
        class="group"
        :class="{'selected': isSelected}"
        @click="selectGroup()"
    >
        <ui-badge :abbreviation="data.name" :color="data.color" design="xs" />
        <span class="name">{{ data.name }}</span>
    </div>
</template>

<script>
    import uiBadge from "@/components/ui/badge";
    
    export default {
        name:"components-groups",
        components: {
			uiBadge,
        },
        
        props: {
            data: {
                type: [Array, Object],
                required: true,
                default: function() {
                    return {}
                }
            },

            index: {
                type: [Number, String],
                required: false,
                default: 0,
            }
        },

        data: function() {
            return {
                isSelected: null,
            }
        },

        beforeMount: function() {
            // eslint-disable-next-line vue/valid-next-tick
            this.$nextTick(() => {
                this.isSelected = this.data.selected;
            });
        },

        methods: {			
			selectGroup: function () {
                this.isSelected = !this.isSelected;
                this.$emit('group-changed', this.data);
			},			
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>